import { useWindowDimensions } from 'react-native';

export const useResponsiveDesign = () => {
  const { width, height } = useWindowDimensions();
  const deviceHeight = height;
  const maxTabletHeight = 834; // height of iPad Air 11" 2024

  return deviceHeight <= maxTabletHeight;
};
